import BootstrapVue from 'bootstrap-vue'
import Murmur from '@icij/murmur'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import VueScrollactive from 'vue-scrollactive'
import VueScrollTo from 'vue-scrollto'
import VueWait from 'vue-wait'
import { library as fortawesome } from '@fortawesome/fontawesome-svg-core'

import * as icons from '@/utils/font-awesome'
import { routes, guards } from './router'
import './main.scss'

Vue.config.productionTip = false
Murmur.config.set('project.name', 'Pandora Papers')
Murmur.config.set('app.name', 'Charts')
Murmur.config.set('app.url', 'https://projects.icij.org/investigations/pandora-papers/charts')
Murmur.config.set('sharing-options.title', 'Pandora Papers')
Murmur.config.set('sharing-options.url', 'https://www.icij.org/investigations/pandora-papers/')

// Register exported icons
fortawesome.add(...Object.values(icons))

Vue.use(BootstrapVue)
Vue.use(Murmur)
Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(VueScrollactive)
Vue.use(VueScrollTo)
Vue.use(VueWait)

const wait = new VueWait()
const config = Murmur.config
const mode = 'history'
const router = guards({ router: new VueRouter({ routes, mode }), config })
const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView', { props: { name: 'header' } }),
  h('RouterView'),
  h('RouterView', { props: { name: 'footer' } })
])

// Configure
Vue.use(VueAnalytics, {
  id: 'UA-3383794-15',
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: '/pandora-papers/charts' + route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

// Create a mount the main Vue instance
new Vue({ router, render, wait }).$mount('#app')
